import { createSlice, createAsyncThunk, PayloadAction } from "@reduxjs/toolkit";

interface ResourceMeta {
    id: number;
    type: string; // booklet, content, video
    name: string;
    // Add other resource fields as needed
}

interface CourseResourceMetaState {
    data: ResourceMeta[] | null;
    isLoading: boolean;
    error: any;
}

const initialState: CourseResourceMetaState = {
    data: null,
    isLoading: false,
    error: null,
};

const courseResourceMetaSlice = createSlice({
    name: "CourseResourceMetaSlice",
    initialState,
    reducers: {
        fetchList: (state) => {
            state.isLoading = true;
            state.error = null;
        },
        successCourseResourceMeta: (state, action: PayloadAction<ResourceMeta[]>) => {
            state.isLoading = false;
            state.data = action.payload;
            state.error = null;
        },
        failureCourseResourceMeta: (state, action: PayloadAction<any>) => {
            state.isLoading = false;
            state.error = action.payload;
        },
    },
});

export const { fetchList, successCourseResourceMeta, failureCourseResourceMeta } = courseResourceMetaSlice.actions;
export default courseResourceMetaSlice.reducer;
